import { MaskLine, FadeIn, Overline } from "@/components/motion";
import { CONTACTS } from "@/lib/site";

const SECTIONS = [
  {
    title: "Titolare del trattamento",
    text: "Il titolare del trattamento è Synapses — Centro specialistico in Neurologia e Medicina del Sonno, Via Avigliana 38, 10138 Torino (TO), raggiungibile all'indirizzo email " + CONTACTS.email + ". Direttore sanitario: Dott. Enrico Cavallo.",
  },
  {
    title: "Dati raccolti e finalità",
    text: "Tramite il modulo di richiesta appuntamento raccogliamo nome, contatti (telefono ed email), la prestazione di interesse, le preferenze di data e orario ed eventuali note che il paziente sceglie liberamente di condividere, che possono includere dati relativi alla salute. I dati sono trattati esclusivamente per ricontattare l'interessato, confermare la disponibilità o proporre alternative di orario.",
  },
  {
    title: "Base giuridica",
    text: "Il trattamento dei dati personali comuni si fonda sull'esecuzione di misure precontrattuali richieste dall'interessato (art. 6, par. 1, lett. b GDPR). Il trattamento dei dati relativi alla salute si fonda sul consenso esplicito dell'interessato (art. 9, par. 2, lett. a GDPR), raccolto tramite l'apposita casella nel modulo.",
  },
  {
    title: "Conservazione e comunicazione",
    text: "I dati sono conservati per il tempo necessario a gestire la richiesta e comunque non oltre 12 mesi, salvo instaurazione di un rapporto di cura, nel qual caso si applicano i termini di legge sulla documentazione sanitaria. I dati non sono ceduti a terzi né diffusi; possono essere trattati dai professionisti del centro autorizzati al trattamento.",
  },
  {
    title: "Diritti dell'interessato",
    text: "In qualunque momento è possibile esercitare i diritti di accesso, rettifica, cancellazione, limitazione, portabilità e opposizione, nonché revocare il consenso prestato, scrivendo a " + CONTACTS.email + ". È inoltre possibile proporre reclamo al Garante per la protezione dei dati personali.",
  },
  {
    title: "Cookie",
    text: "Questo sito utilizza esclusivamente strumenti tecnici necessari al funzionamento delle pagine. Non vengono installati cookie di profilazione.",
  },
];

export default function Privacy() {
  return (
    <>
      <section className="bg-crema pt-40 pb-16 lg:pt-52 lg:pb-20">
        <div className="max-w-4xl mx-auto px-6 lg:px-10">
          <FadeIn>
            <Overline>Informativa privacy</Overline>
          </FadeIn>
          <h1 className="mt-8 font-sora font-extrabold tracking-tighter text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-ink" data-testid="privacy-title">
            <MaskLine delay={0.15}>I tuoi dati,</MaskLine>
            <MaskLine delay={0.3}>
              <span className="text-indaco">con rispetto.</span>
            </MaskLine>
          </h1>
        </div>
      </section>
      <section className="bg-crema pb-28 lg:pb-40">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 space-y-12">
          {SECTIONS.map((s, i) => (
            <FadeIn key={s.title} delay={0.05 * i}>
              <div className="border-t border-viole/20 pt-8" data-testid={`privacy-section-${i}`}>
                <h2 className="font-sora font-bold tracking-tight text-xl text-ink">{s.title}</h2>
                <p className="mt-4 text-viole leading-relaxed">{s.text}</p>
              </div>
            </FadeIn>
          ))}
          <p className="text-sm text-viole/70 italic">
            Documento informativo redatto ai sensi degli artt. 13 e 14 del Regolamento (UE) 2016/679.
            Ultimo aggiornamento: luglio 2026.
          </p>
        </div>
      </section>
    </>
  );
}
